import messages from './messages.tsx';

export const isQuickReply = (input: string): input is keyof typeof messages => {
	return Object.keys(messages).includes(input);
};
